import React from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    className?: string;
}
const BetaBadge = ({ className = 'text-xs py-1.5' }: Props) => (
    <span
        className={twMerge(
            'bg-yellow rounded-lg px-2 font-bold text-gray-800 uppercase dark:text-white',
            className,
        )}
    >
        {'BETA'}
    </span>
);

export default BetaBadge;
